<template>
	<section class="member-center">
		<header class="member-center__hero">
			<div class="member-center__hero-left">
				<div class="member-center__avatar">
					<img
						v-if="profile.avatar"
						:src="profile.avatar"
						:alt="profile.name"
						class="member-center__avatar-img"
					/>
					<span v-else>{{ profile.initials }}</span>
				</div>
				<div>
					<div class="member-center__hero-name">
						{{ profile.name || '游客' }}
						<el-tag
							type="warning"
							size="mini"
							effect="dark"
							style="margin-left: 8px"
						>
							{{ profile.level || '标准会员' }}
						</el-tag>
					</div>
					<div class="member-center__hero-meta">
						<span v-if="profile.company">{{ profile.company }}</span>
						<span v-if="profile.department" style="margin-left: 12px">{{ profile.department }}</span>
						<span v-if="profile.lastLogin" style="margin-left: 12px">上次登录：{{ profile.lastLogin }}</span>
					</div>
					<div class="member-center__hero-tags" v-if="profile.tags && profile.tags.length > 0">
						<el-tag
							v-for="tag in profile.tags"
							:key="tag"
							size="mini"
							effect="plain"
						>
							{{ tag }}
						</el-tag>
					</div>
				</div>
			</div>
			<!-- <div>
				<el-button type="text" icon="el-icon-mobile-phone">
					下载 App
				</el-button>
				<el-button type="primary" plain icon="el-icon-user">
					编辑资料
				</el-button>
			</div> -->
		</header>
		<div class="member-center__body">
			<aside>
				<el-menu
					:default-active="active"
					class="member-center__menu"
					@select="handleSelect"
				>
					<el-menu-item
						v-for="item in modules"
						:index="item.key"
						:key="item.key"
					>
						<i :class="item.icon" />
						<span>{{ item.label }}</span>
					</el-menu-item>
				</el-menu>
			</aside>
			<main class="member-center__content">
				<slot />
			</main>
		</div>
	</section>
</template>

<script>
export default {
	name: 'MemberLayout',
	props: {
		modules: {
			type: Array,
			default: () => []
		},
		active: {
			type: String,
			default: ''
		},
		profile: {
			type: Object,
			default: () => ({
				name: '游客',
				initials: 'Y',
				level: '标准会员',
				lastLogin: '--',
				tags: [],
				company: '一起飞'
			})
		}
	},
	methods: {
		handleSelect(key) {
			this.$emit('change', key)
		}
	}
}
</script>

<style lang="scss">
@import '@/style/member-center/index.scss';
</style>

